// Owner-approved inline artwork: no network dependency or missing-file layout shift.
export const GameBadge = ({ milestone, crown = false, label, testId }) => (
  <svg viewBox="0 0 128 128" role="img" aria-label={label} data-testid={testId}
    className="game-badge" width="40" height="40">
    <title>{label}</title>
    {crown ? <>
      <path fill="#FFD700" d="M14 34 37 52 64 19 91 52 114 34 103 94 25 94Z M25 100H103V111H25Z" />
      <path fill="#FF3B30" d="m64 55 11 16-11 16-11-16Z" />
    </> : <>
      {milestone >= 8 && <path fill="#FFD700" d="m32 4 25 0-7 8H37L12 54v20l25 42h13l7 8H32L4 77V51Z M96 4H71l7 8h13l25 42v20l-25 42H78l-7 8h25l28-47V51Z" />}
      <path fill={milestone === 12 ? "#FF3B30" : "#FFD700"} d="M38 18H90L116 64 90 110H38L12 64Z" />
      {milestone === 4 && <path fill="#FF3B30" d="M23 60H34V68H23Z M94 60H105V68H94Z" />}
      <text x="64" y="87" textAnchor="middle" fill="#0A0A0A" fontFamily="'Barlow Condensed', Impact, sans-serif" fontWeight="900" fontSize={milestone === 12 ? 65 : 82}>{milestone}</text>
    </>}
  </svg>
);